/**
 *  【意见反馈】入口页
 * */ 
import React from 'react';
import PropTypes from 'prop-types';
import Main from './pages/main';

const StarOrder = ({history, match}) => {
    return <Main history={history} match={match}/>;
};

StarOrder.propTypes = { 
    history: PropTypes.object,
    match: PropTypes.object
};

export default StarOrder;